export const get = (index, def = undefined) => {
  const value = sessionStorage.getItem(index);
  try {
    return JSON.parse(value) || def;
  } catch (e) {
    return def;
  }
};

export const set = (index, value) => {
  sessionStorage.setItem(index, JSON.stringify(value));
};

export const remove = index => {
  const value = get(index);
  sessionStorage.removeItem(index);
  return value;
};
